module.exports = __webpack_public_path__ + "assets/img/enter.4c8ddd09.svg";